import React, { } from 'react';
import $ from 'jquery';

import { isBool , isString , isArray} from './general';
import {  makeStore } from './pile';

const popupStore = makeStore({
    popup : null
});

export function showPopup(popup){
    popupStore.dispatch((state)=>{
        state.popup = popup;
    })  
}

export function hidePopup(){
    popupStore.dispatch(state=>{
        state.popup = null;
    })
}

export function Popup() {
  
    const popup = popupStore.useSelector(state => state.popup);

    const show = (!!popup);
  
    function close(){
        hidePopup();
        if (popup.onClose){
            popup.onClose();
        }
    }

    function onCancel(){
        close();
        if (popup.onCancel){
            popup.onCancel();
        }
    }

    function onKeyDown(event){
        if (event.key="esc") {
            onCancel();
        }
    }

    function onMouseDown(event){
        if ($(event.target).attr('id')=="popup-background"){
            onCancel();
        }
    }

    function onFinished(value){
        close();
        props.onCompleted(value);
    }

    var popupElement = null;
    if (popup){

        if (popup.at) {
            var top = popup.at.y;
            var left = popup.at.x;
        } else {
            var $target = $("#"+popup.targetId);
            var offset = $target.offset();
            var height = $target.height();
            var top = offset.top + height;
            var left = offset.left;
        }
        var props = $.extend({
            onFinished:onFinished,
        },popup.props);
        popupElement =  React.createElement(popup.tag,popup.props);

    }

    if (popupElement){
        return (<div
            id = "popup-background"
            onKeyDown = {onKeyDown}
            onMouseDown = {onMouseDown}
            style = {{
                width : '100vw',
                height : '100vh',
                position : 'absolute',
            }}
        >
            <div
                style ={{
                    top : top,
                    left : left,   
                    position : 'absolute', 
                }}
            >
                {popupElement}
            </div>
            
        </div>)
    } else {
        return null;
    }

}

export function showMenu({at,targetId,items,onSelected}){
    
    function onFinished (i,item){
        hidePopup();
        item.onClick(i,item)
    }

    showPopup(
        {
            at,
            targetId,
            tag : PopupMenu,
            props : {
                onSelected : onFinished,
                items : items
            }
        }
    );

}

function PopupMenu({style,items,onSelected}){

    var menuItems = $.map(items,(item,i)=>{
        return (<div
            key={i}
            className = "mouseover"
            style = {{
                margin : '0.5em',
                horizontalAlign : 'left',
                textAlign: 'left',
                cursor : 'pointer',
            }}
            onClick={()=>{onSelected(i,item)}}
        >
            {item.name}
        </div>)
    })
    
    style = $.extend({
        backgroundColor : 'white',
        border : 'solid 1px grey',
        // padding : '0.5em',
    },style);

    return (<div
        style = {style}
    >
        {menuItems}
    </div>)
}

